module.exports = __webpack_public_path__ + "img/多数据源集成与整合能力.8e99f183.png";